import apiClient from './client';
import { LoginAcquireResponseMessage } from '@/types/LoginAcquireResponse';

/**
 * Acquires a login session using a Google OAuth token and sets default language.
 * @param primeToken The Google OAuth credential token.
 * @param actorLingo The user language (e.g., from i18n.language).
 * @returns The actor subject response message.
 */
export async function loginAcquire(
  primeToken: string,
  actorLingo: string
): Promise<LoginAcquireResponseMessage> {
  // Send JSON body with primeToken and actorLingo
  const response = await apiClient.post<LoginAcquireResponseMessage>(
    '/secure/login/acquire',
    { primeToken, actorLingo }
  );
  return response.data;
}